import {
    JOBS_INTERVIEW_ACCEPT_REQUEST,
    JOBS_INTERVIEW_ACCEPT_SUCCESS,
    JOBS_INTERVIEW_ACCEPT_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const JobsInterviewPlannedAcceptAction = (data) => {
    return function (dispatch) {
    return new Promise((resolve, reject) => {

      dispatch({
        type: JOBS_INTERVIEW_ACCEPT_REQUEST,
        payload: true,
      });
      
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/interview/accept_or_reject_interview`,
        method: "PUT",
        data: data, 
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(jobworkorderPre(res.data));
          resolve(res.data);

        })
        .catch((error) => {
          dispatch({
            type: JOBS_INTERVIEW_ACCEPT_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
          toast.error("Action performed already!");
          reject(error);

        });
        });
    };
  };
  export const jobworkorderPre = (data) => {
    toast.success("Accepted Successfully!");
    return {
      type: JOBS_INTERVIEW_ACCEPT_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };